import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPlusIconSecondary from './svgs/PlusIconSecondary.js';
import SvgPlusIcon from './svgs/PlusIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var plusIcon = (props => useIcon(SvgPlusIcon, SvgPlusIconSecondary, props));

export { plusIcon as default };
